<template>
    <v-container>
      <v-row>
          <v-col cols="12">
            <div class="text-left" style="margin-bottom:20px;">
                <router-link to="/archive">
                    <v-btn
                        color="secondary"
                        class="text-right"
                        style="width:250px"
                    >
                        Back
                    </v-btn>
                </router-link>
              </div>                  
          </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <h1>Las Vegas</h1>
        </v-col>
      </v-row>
      

      <h2 class="text-left">December</h2>
      <div class="text-left">December 3rd to December 6th - Sydney to Detroit via Houston, then limo to Caesars Windsor, Canada</div>
      <div class="text-left">December 6th - Caesars Windsor, Canada via limo to Detroit airport, then Detroit to Las Vegas</div>
      <div class="text-left">December 10th - Las Vegas to Sydney via San Francisco (Arrive Sydney December 12th)</div>
    </v-container>
  </template>
  
  <script>
  
  //vue 3 style
  import { ref } from 'vue'
  
  export default {
    name: 'HomeView',
    setup() {
    }
  }
  </script>

